import { render, staticRenderFns } from "./estados_crm.vue?vue&type=template&id=160b3506"
import script from "./estados_crm.vue?vue&type=script&lang=js"
export * from "./estados_crm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports